// extracted by mini-css-extract-plugin
export default {"main":"list-slov_main__O6kFl","list":"list-slov_list__x1t2n"};